import cn from 'classnames';

import { useUnit } from 'state/unit';
import { formatDuration, millisToSec, durationLargestUnit } from 'utils/time';
import useFormattable, { Formattable } from '../formattable';
import styles from './EpisodeDuration.module.scss';

export interface EpisodeDurationProps extends Formattable<string> {
  className?: string;
}

const EpisodeDuration: React.FC<EpisodeDurationProps> = (props) => {
  const { className } = props;

  const unit = useUnit();
  const durationInMillis = unit?.durationMillis ?? 0;
  const durationInSeconds = millisToSec(durationInMillis);

  const formattedDuration = formatDuration(
    durationInMillis,
    durationLargestUnit(durationInSeconds) === 'hours' ? 'HH:mm:ss' : 'mm:ss',
  );

  const formattedValue = useFormattable(formattedDuration, props);

  return !unit ? null : (
    <span className={cn(styles.root, className)}>{formattedValue}</span>
  );
};

export default EpisodeDuration;
